import React from 'react';
import IAppContext from '../Types/IAppContext';

const appContext: React.Context<IAppContext> = React.createContext({} as IAppContext);

export default appContext;
